import {
  MDSIcon,
  MDSIconColor,
  MDSIconKind,
  MDSSectionSlotName,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
} from "@/mds";
import {
  StyledCardIntegrationInstruction,
  StyledContentList,
  StyledContentSectionTitleWrapper,
  StyledContentStatusWrapper,
} from "@/pages/integrations/shared/integrations.styles";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC } from "react";

interface IntegrationsCalendarHeroProps {
  isConnected: boolean;
}

const POINTS = [
  "Connect any Google and/or Microsoft calendar",
  "Mem will automatically record and transcribe the meeting",
  "Mem will automatically generate summarized notes based on the transcript",
  "You can edit Mem’s notes, or multitask and let Mem do the note-taking in the background",
];

export const IntegrationsCalendarHero: FC<IntegrationsCalendarHeroProps> = observer(
  ({ isConnected }) => {
    return (
      <StyledCardIntegrationInstruction
        title={
          <StyledContentSectionTitleWrapper>
            <HeroGlyph>
              <MDSIcon kind={MDSIconKind.Calendar} color={MDSIconColor.Primary} />
            </HeroGlyph>
            <span>Calendar Integration</span>
          </StyledContentSectionTitleWrapper>
        }
      >
        <div slot={MDSSectionSlotName.HeaderRightAddon}>
          <StyledContentStatusWrapper>
            {isConnected ? "Connected" : "Not connected"}
            <StatusDot $isConnected={isConnected}>
              <MDSIcon
                kind={isConnected ? MDSIconKind.CheckCircleSolid : MDSIconKind.CircleSolid}
                color={isConnected ? MDSIconColor.Positive : MDSIconColor.Danger}
              />
            </StatusDot>
          </StyledContentStatusWrapper>
        </div>

        <HeroBody>
          <HeroList as="ol">
            {POINTS.map(point => (
              <li key={point}>
                <MDSText variant={MDSTextVariant.ParagraphS} color={MDSTextColor.Primary}>
                  {point}
                </MDSText>
              </li>
            ))}
          </HeroList>
        </HeroBody>
      </StyledCardIntegrationInstruction>
    );
  }
);

const HeroGlyph = styled.div`
  width: 36px;
  height: 36px;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.background.list.hover};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const StatusDot = styled.span<{ $isConnected: boolean }>`
  display: inline-flex;
  align-items: center;
`;

const HeroBody = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing[5]}`};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
`;

const HeroList = styled(StyledContentList)`
  padding-left: ${({ theme }) => theme.spacing[6]};
  list-style-type: decimal;

  li {
    margin-left: ${({ theme }) => theme.spacing[1]};
  }
`;
